// extracted by mini-css-extract-plugin
export default {"top":"EmployeeHeader_top__gied2","box":"EmployeeHeader_box__anh+j","addButton":"EmployeeHeader_addButton__OXLP9"};